import { WORKFLOW_CATEGORY_BOTS } from '../constants/workflowCategories';

/** Programmatic “interface” per workflow category: required / optional singleton event nodes. */

export const BASE_REQUIRED_EVENTS = [
  {
    type: 'wfTrigger',
    maxCount: 1,
    paletteTitle: 'Start',
    paletteSubtitle: 'Entry point',
    defaultData: { label: 'Start', hint: 'Entry point' }
  }
];

/** Optional Telegram inbound handlers (Bots workflows). Data-only; no runtime logic here. */
export const BOTS_OPTIONAL_TELEGRAM_EVENTS = [
  {
    type: 'wfEventTgText',
    paletteTitle: 'Telegram · Text',
    paletteSubtitle: 'Any text message',
    defaultData: { label: 'TG Text', hint: 'Text messages', telegramKind: 'text' }
  },
  {
    type: 'wfEventTgPhoto',
    paletteTitle: 'Telegram · Photo',
    paletteSubtitle: 'Photo messages',
    defaultData: { label: 'TG Photo', hint: 'Photo', telegramKind: 'photo' }
  },
  {
    type: 'wfEventTgVideo',
    paletteTitle: 'Telegram · Video',
    paletteSubtitle: 'Video messages',
    defaultData: { label: 'TG Video', hint: 'Video', telegramKind: 'video' }
  },
  {
    type: 'wfEventTgFile',
    paletteTitle: 'Telegram · File',
    paletteSubtitle: 'Document / file',
    defaultData: { label: 'TG File', hint: 'File', telegramKind: 'file' }
  },
  {
    type: 'wfEventTgSticker',
    paletteTitle: 'Telegram · Sticker',
    paletteSubtitle: 'Sticker',
    defaultData: { label: 'TG Sticker', hint: 'Sticker', telegramKind: 'sticker' }
  },
  {
    type: 'wfEventTgAnimation',
    paletteTitle: 'Telegram · GIF',
    paletteSubtitle: 'Animation / GIF',
    defaultData: { label: 'TG GIF', hint: 'Animation', telegramKind: 'animation' }
  }
];

export function getPaletteEventsForCategory(categoryId) {
  const required = BASE_REQUIRED_EVENTS.map((e) => ({
    section: 'required',
    ...e
  }));
  if (categoryId === WORKFLOW_CATEGORY_BOTS) {
    return [
      ...required,
      ...BOTS_OPTIONAL_TELEGRAM_EVENTS.map((e) => ({
        section: 'optional',
        maxCount: 1,
        ...e
      }))
    ];
  }
  return required;
}

export function eventMaxCount(entry) {
  return entry.maxCount ?? 1;
}

export function requiresSingletonStart() {
  return true;
}
